module.exports = __webpack_public_path__ + "static/media/AeroGCS.32e2fc8f.svg";